var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"height":_vm.bannerHeight + 'px',"arrow":"always","indicator-position":"none"}},_vm._l((_vm.carouselList),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{ref:"bannerHeight",refInFor:true,staticClass:"carousel-img",attrs:{"src":_vm.newBaseurl + item},on:{"load":_vm.imgLoad}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }